import { useCallback } from "react";

import { usePitPortClient } from "hooks/api/usePitPortClient";

/**
 * 貸主ユーザーを作成する
 * @param ownerEntityId
 * @param data
 * @returns OwnerUser
 */
export const useCreateOwnerUser = () => {
  const client = usePitPortClient();

  const create = useCallback(
    async (ownerEntityId: string, data: OwnerUserCreateRequest) => {
      return await client.client({
        method: "POST",
        url: `/owner-entities/${ownerEntityId}/owner-users`,
        data: {
          ...data,
        },
      });
    },
    [client]
  );

  return { create };
};
